export default __webpack_public_path__ + "static/media/Screenshot5.0691efdb.png";